module.exports = __webpack_public_path__ + "img/glocal-user.572bd943.jpg";